import React from 'react'

export default function Structure() {
  return (
    <div>
      MAIN
    </div>
  )
}
